import styled from 'styled-components';

import PromptCopyCard from '../PromptCopyCard';
import {
  LeftContent,
  PromptText,
  CopyButton
} from '../PromptCopyCard/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.45;
  color: ${({ theme }) => theme.text.actionBar};
`;

export const CommandCard = styled(PromptCopyCard)`
  min-height: 176px;

  ${LeftContent} {
    align-items: flex-start;
    padding-top: 24px;
    padding-bottom: 24px;
  }

  ${PromptText} {
    width: 100%;
  }

  ${CopyButton} {
    align-self: flex-start;
  }
`;

export const CommandTextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CommandLine = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.text.workspaceItem};
  white-space: pre-wrap;
  word-break: break-word;
`;

export const SectionText = styled.div`
  line-height: 22px;
  font-weight: 335;
  color: ${({ theme }) => theme.text.workspaceItem};
`;
